import { dataExpTagConfig } from '@/components/product/const';
import ArrowIcon from '@/images/icon/arrow-default.svg';
import { EXPOSURE_RECORD } from '@/tracks/25217';
import CDNImage from '../cdnImage/cdnImage';
import SafeLink from '../SafeLink';
import styles from './index.module.scss';
import RichComponent from './richComponent';
interface PlusFloorProps {
  plusIconUrl: string;
  guideTextIntergation: string;
  guideTextNoLabelIntergation: string;
  skuId: string;
}
export default function PlusFloor({
  plusIconUrl,
  guideTextIntergation,
  guideTextNoLabelIntergation,
  skuId,
}: PlusFloorProps) {
  return (
    plusIconUrl &&
    guideTextIntergation && (
      <div
        className={styles.plusFloor}
        exptag={'exp|' + EXPOSURE_RECORD.Productdetail_MemberPurchaseFloor_Expo}
        data-exptag-config={dataExpTagConfig}
        data-exptag-json-param={JSON.stringify({
          mainskuid: skuId,
          displayText: guideTextNoLabelIntergation,
        })}
      >
        <SafeLink
          href={`/membership`}
          trackClickParams={{
            event_id: 'Productdetail_MemberPurchaseFloor_Click',
            json_param: {
              mainskuid: skuId,
              displayText: guideTextNoLabelIntergation,
            },
          }}
        >
          <CDNImage className={styles.icon} src={plusIconUrl} width={28} height={14} />
          <RichComponent
            className={styles.richText}
            data={guideTextIntergation}
            isShadowDom={false}
          />
          <ArrowIcon className={styles.arrow} />
        </SafeLink>
      </div>
    )
  );
}
